import { toDatetime, toDate } from '@utils/date';
import { toNumber, toCurrency, toPercentage } from '@utils/number';

// Kept as a mixin object (rather than removed) because ~17 components still locally opt into it via
// `mixins: [to]` — see src/mixins/index.js for why it's empty here.
export default {};

export const methods = {
    toNumber,
    toCurrency,
    toPercentage,
    toDatetime,
    toDate
};
